import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { TranslateService } from '@ngx-translate/core';
//import { UserIdleService } from 'angular-user-idle';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  private key: string;
  constructor(private envServiceProvider: EnvironmentService, public translate: TranslateService,
    private router: Router, private bnIdle: BnNgIdleService) {




    translate.addLangs(['en', 'fr']);
    if (localStorage.getItem('locale')) {
      const browserLang = localStorage.getItem('locale');
      // const browserLang = translate.getBrowserLang();
      // const browserLang = 'en';
      translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
    } else {
      localStorage.setItem('locale', 'en');
      translate.setDefaultLang('en');
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart && event.url.indexOf('reset') !== -1) {
        var key = event.url.split('?key=')[1];
        this.envServiceProvider.sendMessage(decodeURIComponent(key));
      }
    });

  }

  ngOnInit() {
    this.bnIdle.startWatching(3600).subscribe((isTimedOut: boolean) => {
      if (isTimedOut) {
        console.log('session expired');
        localStorage.clear();
        this.router.navigate(['/']);
      }
    });

    this.envServiceProvider.config({
      domains: {
        local: ["192.168.2.2", "localhost"],
        betaDevPortal: ["beta-developer.unificationengine.com"],
        stagingDevPortal: ["staging-developer.unificationengine.com"],
        devPortal: ["developer.unificationengine.com"],
      },
      vars: {
        local: {
          appName: "ue-developer-portal",
          // apiUrl: 'https://developer-api.unificationengine.com',
        //  apiUrl: 'https://beta-developer-api.unificationengine.com',
         apiUrl: "https://staging-developer-api.unificationengine.com",
          // apiUrl: "http://192.168.2.3:7086",
          Authorization: "iotm6523457",
          clientID: "221460181203789",
          // redirectURL:
          // "http://192.168.2.2:7085",
          redirectURL:
            "https://beta-developer-api.unificationengine.com/v2/callback/fb/auth",
          airbnbredirectURL:
            "https://beta-developer-api.unificationengine.com/v2/callback/airbnb/auth",
          twitchredirectURL:
            "https://beta-developer-api.unificationengine.com/v2/callback/twitch/auth",
          instagramredirectURL:
            "https://beta-developer-api.unificationengine.com/v2/callback/instagram/auth",
          //clientID: "173021482730253",
          airbnbClientId: "4xi52q7r8ytjxdzg9awwp5d33",
          twitchClientId: "xgb41d5t98rh4k50wmkamh2zo4eq0x",
          instagramClientId: "221460181203789",
          tiktokClientId: "7481464809368584193",
          tiktokRedirectURL:"https://5581-202-88-246-112.ngrok-free.app/v2/callback/tiktok/auth"
        },
        betaDevPortal: {
          appName: "ue-developer-portal",
          apiUrl: "https://beta-developer-api.unificationengine.com",
          // apiUrl: "https://developer-api.unificationengine.com",
          Authorization: "iotm6523457",
          clientID: "173021482730253", //"221460181203789",
          // clientID: "221460181203789",
          redirectURL:
            "https://beta-developer-api.unificationengine.com/v2/callback/fb/auth",
          airbnbredirectURL:
            "https://beta-developer-api.unificationengine.com/v2/callback/airbnb/auth",
          twitchredirectURL:
            "https://beta-developer-api.unificationengine.com/v2/callback/twitch/auth",
          instagramredirectURL:
            "https://beta-developer-api.unificationengine.com/v2/callback/instagram/auth",
          airbnbClientId: "4xi52q7r8ytjxdzg9awwp5d33",
          twitchClientId: "xgb41d5t98rh4k50wmkamh2zo4eq0x",
          instagramClientId: "221460181203789",
          tiktokClientId: "7481464809368584193",
          tiktokRedirectURL:"https://beta-developer-api.unificationengine.com/v2/callback/tiktok/auth"
        },
        stagingDevPortal: {
          appName: "ue-developer-portal",
          apiUrl: "https://staging-developer-api.unificationengine.com",
          // apiUrl: "https://developer-api.unificationengine.com",
          Authorization: "iotm6523457",
          clientID: "173021482730253", //"221460181203789",
          // clientID: "221460181203789",
          redirectURL:
            "https://staging-developer-api.unificationengine.com/v2/callback/fb/auth",
          airbnbredirectURL:
            "https://staging-developer-api.unificationengine.com/v2/callback/airbnb/auth",
          twitchredirectURL:
            "https://staging-developer-api.unificationengine.com/v2/callback/twitch/auth",
          instagramredirectURL:
            "https://staging-developer-api.unificationengine.com/v2/callback/instagram/auth",
          airbnbClientId: "4xi52q7r8ytjxdzg9awwp5d33",
          twitchClientId: "xgb41d5t98rh4k50wmkamh2zo4eq0x",
          instagramClientId: "221460181203789",
          tiktokClientId: "7481464809368584193",
          tiktokRedirectURL:"https://staging-developer-api.unificationengine.com/v2/callback/tiktok/auth"
        },
        devPortal: {
          appName: "ue-developer-portal",
          apiUrl: "https://developer-api.unificationengine.com",
          Authorization: "iotm6523457",
          clientID: "221460181203789",
          redirectURL:
            "https://developer-api.unificationengine.com/v2/callback/fb/auth",
          airbnbredirectURL:
            "https://developer-api.unificationengine.com/v2/callback/airbnb/auth",
          twitchredirectURL:
            "https://developer-api.unificationengine.com/v2/callback/twitch/auth",
          instagramredirectURL:
            "https://developer-api.unificationengine.com/v2/callback/instagram/auth",
          airbnbClientId: "4xi52q7r8ytjxdzg9awwp5d33",
          twitchClientId: "xgb41d5t98rh4k50wmkamh2zo4eq0x",
          instagramClientId: "221460181203789",
          tiktokClientId: "7481464809368584193",
          tiktokRedirectURL:"https://developer-api.unificationengine.com/v2/callback/tiktok/auth"
        },
        defaults: {
          appName: "ue-developer-portal",
          apiUrl: "https://developer-api.unificationengine.com",
          Authorization: "iotm6523457",
          clientID: "221460181203789",
          redirectURL:
            "https://developer-api.unificationengine.com/v2/callback/fb/auth",
          airbnbredirectURL:
            "https://developer-api.unificationengine.com/v2/callback/airbnb/auth",
          twitchredirectURL:
            "https://developer-api.unificationengine.com/v2/callback/twitch/auth",
          instagramredirectURL:
            "https://developer-api.unificationengine.com/v2/callback/instagram/auth",
          airbnbClientId: "4xi52q7r8ytjxdzg9awwp5d33",
          twitchClientId: "xgb41d5t98rh4k50wmkamh2zo4eq0x",
          instagramClientId: "221460181203789",
          tiktokClientId: "7481464809368584193",
          tiktokRedirectURL:"https://developer-api.unificationengine.com/v2/callback/tiktok/auth"
        },
      },
      credentials: {
        username: "dWViYWNrZW5kYWRtaW51c2Vy", //base64 encode
        password: "QmxhY2shY2VUMWdlcldhdmU=", //base64 encode
      },
    });
    this.envServiceProvider.check();
    //Start watching for user inactivity.
		/* this.userIdle.startWatching();

		// Start watching when user idle is starting.
		this.userIdle.onTimerStart().subscribe(count => console.log(count));

		// Start watch when time is up.
		this.userIdle.onTimeout().subscribe(() => {
			console.log('Time is up!')
			this.userIdle.resetTimer();
			this.logout();
		}); */
  }
  logout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }
}
